const AVAILABLE_FORM_FIELDS = {
  name: "name",
  grossValue: "gross",
  currency: "assetCurrency",
  reviewDate: "reviewDate",
  monthlyContribution: "monthlyContribution",
  employerMonthlyContribution: "employerMonthlyContribution",
  annualIncreaseInMonthlyContribution: "annualIncreaseInMonthlyContribution",
  monthlyIncome: "monthlyIncome",
  allowAutomatedIncomeCalculation: "allowAutomatedIncomeCalculation",
  interestRate: "interestRate",
  bondInterestRate: "bondInterestRate",
  liability: "liability",
  termOfDebt: "termOfDebt",
  monthlyProfit: "monthlyProfit",
  contractNumber: "contractNumber",
  serviceProviderId: "serviceProviderId",
  baseCost: "baseCost",
  changeGrossIncomeEvent: "changeGrossIncomeEvent",
  changeMonthlyContributionEvent: "changeMonthlyContributionEvent",
  matureRetirementAssetEvent: "matureRetirementAssetEvent",
  potBreakdown: "potBreakdown",
  savingsPotAnnualWithdrawal: "savingsPotAnnualWithdrawal",
};

export const ASSET_ALLOCATION_FIELDS = [
  "domesticEquity",
  "domesticProperty",
  "domesticBonds",
  "domesticCash",
  "offshoreEquity",
  "offshoreProperty",
  "offshoreBonds",
  "offshoreCash",
];

export const SHARED_VALIDATION_FIELDS = ["allocationTotal"];

const AssetFieldGroupIDs = {
  details: "details",
  actions: "actions",
  additional: "additional",
};

export const AssetFieldGroupsNames = {
  [AssetFieldGroupIDs.details]: "Basic details",
  [AssetFieldGroupIDs.actions]: "Contributions & withdrawals",
  [AssetFieldGroupIDs.additional]: "Additional details",
};

const addFieldToGroup = (fields, fieldGroupID, newField) => {
  if (fields[fieldGroupID] === undefined) {
    fields[fieldGroupID] = [];
  }

  fields[fieldGroupID].push(newField);

  return fields;
};

export const formFieldsInGroupsForAssetType = (asset, retired) => {
  const assetType = asset.asset_type;
  let sharedFields = addFieldToGroup(
    {},
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.name
  );

  return fieldsForAssetType[assetType](sharedFields, retired);
};

const retirementVehicleFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.potBreakdown
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.savingsPotAnnualWithdrawal
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyContribution
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.employerMonthlyContribution
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.annualIncreaseInMonthlyContribution
    );
  }

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeMonthlyContributionEvent
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.matureRetirementAssetEvent
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.serviceProviderId
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.contractNumber
  );

  return fields;
};

const discretionaryFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyIncome
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
    );
  }

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyContribution
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.annualIncreaseInMonthlyContribution
    );
  }

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeMonthlyContributionEvent
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.serviceProviderId
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.contractNumber
  );

  return fields;
};

const retirementSavingsPotFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyIncome
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
    );
  }

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyContribution
    );
  }

  return fields;
};

// Specific asset fields
const retirementAnnuityFields = (fields, retired) => {
  return retirementVehicleFields(fields, retired);
};

const preservationFields = (fields, _) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.serviceProviderId
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.contractNumber
  );

  return fields;
};

const livingAnnuityFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.reviewDate
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyIncome
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
    );
  }
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.serviceProviderId
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.contractNumber
  );

  return fields;
};

const offshoreInvestmentFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.currency
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyIncome
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
    );
  }
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyContribution
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.annualIncreaseInMonthlyContribution
    );
  }
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeMonthlyContributionEvent
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.serviceProviderId
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.additional,
    AVAILABLE_FORM_FIELDS.contractNumber
  );

  return fields;
};

const moneyMarketFields = (fields, retired) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );

  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyIncome
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
    );
  }

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );
  if (!retired) {
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.monthlyContribution
    );
    fields = addFieldToGroup(
      fields,
      AssetFieldGroupIDs.actions,
      AVAILABLE_FORM_FIELDS.annualIncreaseInMonthlyContribution
    );
  }
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeMonthlyContributionEvent
  );

  return fields;
};

const investmentPropertyFields = (fields, _) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.liability
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.termOfDebt
  );

  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.monthlyContribution
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.monthlyProfit
  );

  return fields;
};

const currentAccountFields = (fields, _) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.grossValue
  );

  return fields;
};

const otherIncomeFields = (fields, _) => {
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.monthlyIncome
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.allowAutomatedIncomeCalculation
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.interestRate
  );
  fields = addFieldToGroup(
    fields,
    AssetFieldGroupIDs.actions,
    AVAILABLE_FORM_FIELDS.changeGrossIncomeEvent
  );

  return fields;
};

const taxFreeSavingsAccountFields = (fields, retired) => {
  let tfsaFields = discretionaryFields(fields, retired);

  fields = addFieldToGroup(
    tfsaFields,
    AssetFieldGroupIDs.details,
    AVAILABLE_FORM_FIELDS.baseCost
  );

  return tfsaFields;
};

const fieldsForAssetType = {
  pension: retirementVehicleFields,
  provident: retirementVehicleFields,
  retirement_annuity: retirementAnnuityFields,

  living_annuity: livingAnnuityFields,

  pension_preservation: preservationFields,
  provident_preservation: preservationFields,

  unit_trust: discretionaryFields,
  share_portfolio: discretionaryFields,
  endowment: discretionaryFields,
  tax_free_savings_account: taxFreeSavingsAccountFields,
  savings_pot: retirementSavingsPotFields,

  offshore_investment: offshoreInvestmentFields,

  money_market: moneyMarketFields,

  investment_property: investmentPropertyFields,

  other_income: otherIncomeFields,

  current_account: currentAccountFields,
};
